import React from "react";
import { formatClaimLanguage } from "./claimViewUtils";

const ClaimUrlViewOnly = ({ claimDetail = {} }) => {
  const languageLabel = formatClaimLanguage(claimDetail?.language);

  return (
    <div className="sectionpadding bg-white mb-30 claim-form-view-only-panel">
      <p className="claim-form-view-only-title mb-0">
        Redirectional URL - For {languageLabel}
      </p>
      <hr className="my-3" />
      <p className="claim-form-view-only-value mb-0">
        {claimDetail?.urlData || "-"}
      </p>
    </div>
  );
};

export default ClaimUrlViewOnly;
